import { SET_INSURANCE_TYPE } from './insuranceTypeActions';
import { INSURANCE_TYPES } from '../../../constants';

const InitialState = INSURANCE_TYPES.HEALTH;

export default function insuranceTypeReducer(state = InitialState, action) {
    const {
        type,
        payload,
    } = action;

    switch (type) {
        case SET_INSURANCE_TYPE:
            if (payload.insuranceType !== INSURANCE_TYPES.HEALTH
                && payload.insuranceType !== INSURANCE_TYPES.DENTAL
                && payload.insuranceType !== INSURANCE_TYPES.VISION) {
                return INSURANCE_TYPES.HEALTH;
            }
            return payload.insuranceType;

        default:
            return state;
    }
}
